<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <button class="modal-close" @click="close">×</button>
      <h2>🚀 {{ $t("UpgradetoPrime") }}</h2>
      <p class="modal-desc">
        {{ $t("Unlockboth") }}
      </p>
      <div class="modal-actions">
        <button class="modal-upgrade" @click="upgrade">
          {{ $t("UpgradetoPrime99") }}
        </button>
        <button class="modal-cancel" @click="close">
          {{ $t("CancelKeep") }}
        </button>
      </div>
      <div class="modal-tip">
        <span>💡 {{ $t("ThePrimeversion") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrimeUpgradeModal",
  i18n: require("../subi18n"),
  methods: {
    close() {
      this.$emit("close");
    },
    upgrade() {
      this.$emit("upgrade");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-content {
  background: #fdf2d6;
  border-radius: 12px;
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.15);
  padding: 32px 24px 24px 24px;
  max-width: 700px;
  width: 90vw;
  position: relative;
}
.modal-close {
  position: absolute;
  right: 16px;
  top: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #000;
}
.modal-desc {
  margin: 16px 0 24px 0;
  font-style: italic;
  color: #444;
}
.modal-actions {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.modal-upgrade {
  background: #00796b;
  color: #fff;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: bold;
  cursor: pointer;
  /* flex: 1 1 180px; */
}
.modal-cancel {
  background: #fff;
  color: #222;
  border: 1px solid #bbb;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  /* flex: 1 1 180px; */
}
.modal-tip {
  margin-top: 8px;
  color: #ff9800;
  font-size: 0.95em;
  display: flex;
  align-items: center;
}
@media (max-width: 600px) {
  .modal-content {
    padding: 20px 8px 16px 8px;
    max-width: 98vw;
    font-size: 0.98em;
  }
  .modal-actions {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
